import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import {BeatLoader} from "react-spinners";
import loadingGif from "../../assets/img/loading.gif";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;

function numDifferentiation(val, amount_type) {
    if(amount_type==='Thousand'){
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    if(amount_type==='Lakhs'){
        if(val >= 100000) val = (val/100000).toFixed(2) + ' L';
        if(val >= 1000) val = (val/1000).toFixed(2) + ' K';
        if(val>0 && val<1000) val = val.toFixed(1);
    }
    return val;
}

function enabledBody() {
    $('body').removeClass("back-disabled");
}

function disabledBody() {
    $('body').addClass("back-disabled");
}

var todayDate = new Date();
var timestamp  = new Date().getTime();
var yesterday = new Date(Date.now() - 24*60*60*1000);
var tod = moment(todayDate).format('MM/DD/YYYY');
var yest = moment(yesterday).format('MM/DD/YYYY');
var todShow = moment(todayDate).format('D MMM YYYY');
var yestShow = moment(yesterday).format('D MMM YYYY');
var todSend = moment(todayDate).format('YYYY-MM-DD');
var yestSend = moment(yesterday).format('YYYY-MM-DD');

var lastTenDays = [];
for (var i = 1; i <= 10; i++) {
    var date = new Date(Date.now() -i*24*60*60*1000);
    var dateFormat = moment(date).format('YYYY-MM-DD');
    lastTenDays.push(dateFormat)
}
Array.prototype.move = function(from,to){
    this.splice(to,0,this.splice(from,1)[0]);
    return this;
};
function compareValues(val1, val2){
    if(Array.isArray(val1) && Array.isArray(val2)) {
        if(val1.length===val2.length){
            var is_unique = val1.every(i => val2.includes(i));
            if(is_unique===true){
                return false;
            } else {
                return true;
            }
        }
        else{
            return true;
        }

    } else {
        if(val1===val2){
            return false;
        } else {
            return true;
        }
    }
}
class EmiSalesReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            dateTo:tod,
            dateToShow:todShow,
            todSend:todSend,
            yestSend:yestSend,
            datefrom:yest,
            datefromShow:yestShow,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            metric: 'volume',
            loadingtable: true,
            is_record: true,
            is_export: false,
            model_visible : false,
            file_url: '',
            rfile: '',
            is_export2: false,
            categoryLists:[],
            categoryValue:'',
            categoryIDs:'',
            brandLists:[],
            brandValue:'',
            brandIDs:'',
            modelLists:[],
            modelValue:'',
            modelIDs:'',
            tenureLists:[],
            tenureValue:'',
            tenureIDs:'',
            subventionLists:[{value:'Bank', label: 'Bank'},{value:'Brand', label: 'Brand'},{value:'Merchant', label: 'Merchant'},{value:'Innoviti', label: 'Innoviti'} ],
            subventionValue:'',
            subventionIDs:'',
            emiIssuerLists:[],
            emiIssuerValue:'',
            emiIssuerIDs:'',
            emiSchemeLists:[],
            emiSchemeValue:'',
            emiSchemeIDs:'',
            store_level_chain_code:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            is_store_loading: true,
            is_chain_loading: true,
            is_merchant_loading: true,
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            amount_type: 'Thousand',
        }
        this.closeStoreList = this.closeStoreList.bind(this);
    }
    componentDidUpdate() {
        const { storeListOpen } = this.state;
        setTimeout(() => {
            if (storeListOpen) {
                window.addEventListener('click', this.closeStoreList);
            } else {
                window.removeEventListener('click', this.closeStoreList);
            }
        }, 0);
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        }
    componentDidMount() {
        this.subMenuPermission();
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            user_id:decoded._id
        });
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");

        //console.log(decoded.object_type);
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        this._getAllMerchants();
        this._get_acq_banks();
        //this._get_issuing_banks();
        this._get_city();
        this._getCategory();
        this._getBrand();
        this._getModel('');
        this._getTenure();
        this._getEmiIssure();
        this._getEmiScheme();
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code, false,'');
            this.get_filtered_emi_sales_report('','','','','', this.state.yestSend, this.state.todSend, this.state.metric, '', '', '', '', '','','');

            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: decoded.object_code,
                search_type:'innoviti',
                search_object_code: decoded.object_code,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode,false,'');
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'merchant',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode,false,'');
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'chain',
                search_object_code: arrayCode,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData, true);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
                search_code: arrayCode,
                search_type:'store'
            })
        }
        else if(decoded.object_type=='Acquirer Bank') {
            var storeData = [{"value":decoded.object_code, "label":""}]
            this.change_acq_banks(storeData);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: false,
            })
        }
        else {
            this.unauthorize_access();
        }

    }
    subMenuPermission(){
        const token = localStorage.usertoken;
        let subMenuPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        AllAccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Submenu'){
                subMenuPermissions.push(permissionName.access_name);
            }
        });
        if(subMenuPermissions.includes("sales_reports")===false){
            this.unauthorize_access();
        }
    }
    unauthorize_access(){
        localStorage.removeItem("usertoken");
        localStorage.removeItem("userPermission");
        this.setState({
            loggedIn: false
        });
        alert("Unauthorized Access");
        window.location.href = "/";
    }
    get_filtered_emi_sales_report(mids, cids, sids, bids, cityids, fromdate, todate, metric, categoryIDs, brand, model, tenure, subvention, emiIssuer, emiScheme) {
        let windowSize = $(window).width();
        let mcol = "150px";
        let othcol = "65px";
        let autoWidth = true;
        let scrollx = true;
        if(windowSize>1700) {
            mcol = "15%";
            othcol = "7%";
            autoWidth = false;
            scrollx = false;
        }
        if ($.fn.DataTable.isDataTable('#EmiSalesReports')) {
            $('#EmiSalesReports').DataTable().clear().destroy();
        }
        $('#EmiSalesReports').html('');
        if ($.fn.DataTable.isDataTable('#EmiSalesReportsStore')) {
            $('#EmiSalesReportsStore').DataTable().clear().destroy();
        }
        $('#EmiSalesReportsStore').html('');
        this.setState({
            loadingtable: true,
            is_record: true,
            is_export: false,
            is_export2:false
        });
        let tableHeaders=[];
        let tableBody = [];
        let tableHeaders1=[];
        let tableBody1 = [];


            if(Array.isArray(lastTenDays) && lastTenDays.length){

                tableHeaders.push(
                    {
                        sTitle: 'Merchant',
                        mData: 'Merchant',
                        // className: 'details-control',
                        "width": mcol,
                        className: ""
                    },
                    {
                        sTitle: 'Chain',
                        mData: 'Merchant Code',
                        "width": mcol,
                        className: ""
                    });
                tableBody.push({ data: 'Merchant' }, { data: 'Merchant Code' },);
                lastTenDays.forEach(function (k) {
                    tableHeaders.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": othcol,
                        className: "text-right"
                    });
                    tableBody.push({
                        data: k,
                    })
                });

                tableHeaders1.push(
                    {
                        sTitle: 'Store',
                        mData: 'Store',
                        // className: 'details-control',
                        "width": mcol,
                        className: ""
                    },
                    {
                        sTitle: 'UTID',
                        mData: 'Store Code',
                        "width": mcol,
                        className: ""
                    });
                tableBody1.push({ data: 'Store' }, { data: 'Store Code' },);
                lastTenDays.forEach(function (k) {
                    tableHeaders1.push({
                        sTitle: k,
                        mData: k.replace(/\./g, '\\.'),
                        "width": othcol,
                        className: "text-right"
                    });
                    tableBody1.push({
                        data: k,
                    })
                });

                this.setState({
                    loadingtable: false,
                    is_record: true,
                    is_export: true
                });
                this.get_filtered_emi_sales_report_data(mids, cids, sids, bids, cityids, fromdate, todate, metric, categoryIDs, brand, model, tenure, subvention, emiIssuer, emiScheme, tableHeaders, tableBody,tableHeaders1,tableBody1,autoWidth, scrollx);
            } else {
                //alert("hi");
                if ($.fn.DataTable.isDataTable('#EmiSalesReports')) {
                    $('#EmiSalesReports').DataTable().clear().destroy();
                }

                this.setState({
                    is_record: false,
                    loadingtable: false,
                });
            }

    }

    _getEmiScheme(){
        axios.post(config.get('API_URL')+'/reports/get-emi-scheme-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.issuer_scheme_code, label: scheme.issuer_scheme_name})
                });
            }
        });
    }
    changeEmiScheme(optionSelected) {
        let value = '';
        let schemeArray = [];
        if (optionSelected === null) {
            value = null;
        } else {
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
            });
        }
        this.setState({
            emiSchemeIDs: schemeArray,
            emiSchemeValue: optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, schemeArray);
    }
        _getEmiIssure(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-issuer-filter/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuer, index) => {
                    this.state.emiIssuerLists.push({value: issuer.issuer, label: issuer.issuer})
                });
            }
        });
    }
    changeEmiIssuer(optionSelected){
        let value='';
        let emiIssuerArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                emiIssuerArray.push(mids.value)
            });
        }
        this.setState({
            emiIssuerIDs:emiIssuerArray,
            emiIssuerValue:optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, emiIssuerArray, this.state.emiSchemeIDs);
    }
    changeSubvention(optionSelected){
        let value='';
        let subArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                subArray.push(mids.value)
            });
        }
        this.setState({
            subventionIDs:subArray,
            subventionValue:optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, subArray, this.state.emiIssuerIDs, this.state.emiSchemeIDs);

    }
    _getTenure(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-tenure/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((Tenure, index) => {
                    this.state.tenureLists.push({value: Tenure.tenure, label: Tenure.tenure})
                });
            }
        });
    }
    changeTenure(optionSelected){
        let value='';
        let tenureArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                tenureArray.push(mids.value)
            });
        }
        this.setState({
            tenureIDs:tenureArray,
            tenureValue:optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, tenureArray, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }
    _getCategory(){
        axios.post(config.get('API_URL')+'/reports/sales-emi-category/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((category, index) => {
                    this.state.categoryLists.push({value: category.category, label: category.category})
                });
            }
        });
    }
    changeCategory(optionSelected){
        let value='';
        let catArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                catArray.push(mids.value)
            });
        }
        this.setState({
            categoryIDs:catArray,
            categoryValue:optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, catArray, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }

    _getBrand(){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-brand/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((brand, index) => {
                    this.state.brandLists.push({value: brand.brand, label: brand.brand})
                });
            }
        });
    }
    changeBrand(optionSelected){
        let value='';
        let brandArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                brandArray.push(mids.value)
            });
        }
        this.setState({
            brandIDs:brandArray,
            brandValue:optionSelected,
        });
        this.setState({
            modelLists:[],
            modelValue:null,
            modelIDs:'',
        })
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, brandArray, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
        this._getModel(brandArray);
            }

    _getModel(brandArray){
        axios.post(config.get('API_URL')+'/reports/get-sales-emi-model/',{
                yestSend: this.state.yestSend,
                todSend: this.state.todSend,
                brandArray: brandArray
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((model, index) => {
                    this.state.modelLists.push({value: model.model, label: model.model})
                });
            }
        });
    }
    changeModel(optionSelected){
        let value='';
        let modelArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                modelArray.push(mids.value)
            });
        }
        this.setState({
            modelIDs:modelArray,
            modelValue:optionSelected,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, modelArray, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }


    get_filtered_emi_sales_report_data(mids, cids, sids, bids, cityids, fromdate, todate, metric, categoryIDs, brand, model, tenure, subvention, emiIssuer, emiScheme, tableHeaders, tableBody,tableHeaders1,tableBody1,autoWidth, scrollx) {
        var that = this;
        disabledBody()
        var postData = {
            mids: mids,
            cids: cids,
            sids: sids,
            bids: bids,
            cityids: cityids,
            // fr: fr,
            yestSend: fromdate,
            todSend: todate,
            metric: metric,
            sale_type: 'EMI',
            categoryIDs: categoryIDs,
            brand: brand,
            model: model,
            tenure: tenure,
            subvention: subvention,
            emiIssuer:  emiIssuer,
            emiScheme: emiScheme
        };
        var EmiSalesReportsTable = $('#EmiSalesReports').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "autoWidth": autoWidth,
                "responsive": false,
                "scrollX": scrollx,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],

                ajax: {
                    url:config.get('API_URL')+ "/reports/sales-reports",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {
                        enabledBody()
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                        enabledBody()
                    },
                    complete: function (data) {
                        enabledBody()
                    },
                },
                aoColumns:tableHeaders,
                columns: tableBody,
                "columnDefs": [
                    {
                        render: function (data) {
                            return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                        },
                        className: "summary_plus clickable",
                        targets: 0,
                        aTargets: [ -1 ]
                    },
                    {
                        render: function (data) {
                            return '<td >&nbsp;</td>';
                        },
                        targets: 1,
                        aTargets: [ -1 ]
                    },

                ],
            });

        $('#EmiSalesReports').on('click', 'td.clickable', function(e){
            e.preventDefault();
            var tr = $(this).closest('tr');
            var row = EmiSalesReportsTable.row( tr );
            if ( row.child.isShown() ) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            }
            else {
                // Open this row
                if(row.data()!=undefined) {
                    disabledBody()
                    var mcode = row.data()["Merchant Code"];
                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    row.child(loadingImg).show();
                    var ttype = 'EMI';
                    $.ajax({
                        type: 'GET',
                        url:config.get('API_URL')+ "/reports/sales-reports-details?mcode=" + mcode+'&metric='+metric+'&sale_type='+ttype,
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            //console.log(data);
                            content = '<table id="innerTable" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                tableHeaders.map((val, index) =>  {
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation(value[val.sTitle]);
                                    if(val.sTitle=='Chain') {
                                        ClickableTd = '<a href="#" data-chain="'+value["Chain Code"]+'">'+value[val.sTitle]+'</a>';
                                    }
                                    content = content + '<td class="chain_level '+val.className+'"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content,'no-padding').show();
                            tr.addClass('shown');
                            enabledBody()
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
        var EmiSalesReportsStoreTable = '';
        var chainCode = '';
        $('#EmiSalesReports').on('click', 'td.chain_level a', function (e) {
            e.stopImmediatePropagation();
            chainCode = $(this).data("chain");
            disabledBody()
            var postData1 = {
                chain_code: chainCode,
                metric: that.state.metric,
                sale_type: 'EMI',
                sids: that.state.storeID,

            };
            EmiSalesReportsStoreTable = $('#EmiSalesReportsStore').DataTable(
                {
                    order:[],
                    //"dom": 'fltip',
                    "processing": true,
                    "serverSide": true,
                    "bDestroy": true,
                    "paging": true,
                    "pageLength": 20,
                    "bInfo" : false,
                    "sPaginationType": "numbers",
                    "autoWidth": autoWidth,
                    "responsive": false,
                    "scrollX": scrollx,
                    "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],

                    ajax: {
                        url:config.get('API_URL')+ "/reports/sales-reports-store",
                        type: "POST",
                        data: postData1,
                        dataSrc:function ( json ) {
                            enabledBody()
                            return json.data;
                        },
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        error: function (data) {
                            enabledBody()
                        },
                        complete: function (data) {
                            enabledBody()
                        },
                    },
                    aoColumns:tableHeaders1,
                    columns: tableBody1,
                    "columnDefs": [
                        {
                            render: function (data) {
                                return '<td ><div class="collapseFirstTD"><a href="#">'+data+'</a> </div></td>';
                            },
                            className: "summary_plus clickable",
                            targets: 0,
                            aTargets: [ -1 ]
                        },
                        {
                            render: function (data) {
                                return '<td >&nbsp;</td>';
                            },
                            targets: 1,
                            aTargets: [ -1 ]
                        },
                        // {  render: function (data) {
                        //         return '<td >'+numDifferentiation(data)+'</td>';
                        //     },
                        //     "targets": [2,3,4,5,6,7,8,9,10,11]
                        // },
                    ],
                });
            $('html, body').animate({
                scrollTop: $("#StoreLabel").offset().top
            }, 1000);
            that.setState({
                is_export2:true,
                store_level_chain_code: chainCode
            })

        });
        $('#EmiSalesReportsStore').on('click', 'td.clickable', function(e){
            e.preventDefault();
            //alert(chainCode);
            var tr = $(this).closest('tr');
            var row = EmiSalesReportsStoreTable.row( tr );
            if ( row.child.isShown() ) {  //alert("hide");
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
                $(this).closest('tr').find('.summary_minus').addClass('summary_plus');
                $(this).closest('tr').find('.summary_minus').removeClass('summary_minus');
            }
            else {
                // Open this row
                if(row.data()!=undefined) {
                    disabledBody()
                    var scode = row.data()["Store Code"];
                    var content = '';
                    var loadingImg = "<div style='text-align: left'><img src=" + loadingGif + "></div>";
                    row.child(loadingImg).show();
                    $.ajax({
                        type: 'GET',
                        url:config.get('API_URL')+ "/reports/sales-reports-store-details?ccode=" + chainCode+'&metric='+metric+'&scode='+scode+'&sale_type=EMI',
                        beforeSend: function(request) {
                            request.setRequestHeader("Authorization", localStorage.usertoken);
                        },
                        success: function (data) {
                            //console.log(data);
                            content = '<table id="innerTable" cellpadding="5" cellspacing="0" border="0" style="padding-left:0px; width:100%;">';
                            data.data.map((value, index) => {
                                content = content + '<tr>';
                                tableHeaders1.map((val, index) =>  {
                                    //alert(val.sTitle);
                                    var clWidth = val.width;
                                    var ClickableTd = numDifferentiation(value[val.sTitle]);
                                    if(val.sTitle=='UTID') {
                                        ClickableTd = value[val.sTitle];
                                    }
                                    content = content + '<td class="chain_level '+val.className+'"  style="width:' + clWidth + '">' + ClickableTd + ' </td>';
                                });
                                content = content + '</tr>';
                            });
                            content = content + '</table>';
                            row.child(content,'no-padding').show();
                            tr.addClass('shown');
                            enabledBody()
                        },
                        error: function (data) {
                        },
                        complete: function () {

                        }
                    }).done(function () {
                        // printWithAjax();
                    });
                }

                $(this).closest('tr').find('.summary_plus').addClass('summary_minus');
                $(this).closest('tr').find('.summary_plus').removeClass('summary_plus');
            }
        });
    }

    _getAllMerchants(){
        axios.get(config.get('API_URL')+'/reports/get-merchant/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                var mList = []
                response.data.map((merchant, index) => {
                    mList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
                this.setState({
                    merchantList:mList,
                    is_merchant_loading: false
                })
            }
        });
    }

    changeMerchant(login_type, optionSelected){
        let value='';
        let midArray = [];
        if(optionSelected.length<1){
            value = null;
            midArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        var is_enable = compareValues(midArray, this.state.active_mids);
        this.setState({
            merchantID:midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue:[],
            storeID:'',
            storeValue: [],
            isChange: is_enable,
            search_code: midArray,
            search_type:'merchant',
            storeObject:[],
            search_object_code: this.state.object_code,
        });
        this.get_filtered_emi_sales_report(midArray, '', '', this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);
        if(login_type==''){
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code,false,'');
        }

    }

    changeChain(login_type, optionSelected) {
        let value='';
        let cidArray = [];
        if(optionSelected.length<1){
            value = null;
            cidArray = '';
        }
        else{
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value==cids.value);
                    this.state.chainList.move(index,0).join(',');
                }
            });
        }
        var is_enable = compareValues(cidArray, this.state.active_cids);
        this.setState({
            chainID: cidArray,
            chainValue:optionSelected,
            storeID:'',
            storeValue: [],
            isChange: is_enable,
            search_code: cidArray,
            search_type:'chain',
            storeObject:[],
            search_object_code: this.state.merchantID,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, cidArray, '', this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);

        if(login_type==''){
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID,false,'');
        }

    }
    getChain(code, type, object_type, object_code){
        axios.post(config.get('API_URL')+'/reports/get-chain/',{
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID:''});
            response.data.map((chain,index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList:chalinList,
                is_chain_loading: false
            })
        });
    }
    getStore(code, type, object_type, object_code,is_search, search_value) {
        let selected_val = [];
        if(is_search===true){
            selected_val = this.state.storeObject
        }
        this.setState({
            storeList:[],
            is_store_loading: true
        })
        axios.post(config.get('API_URL')+'/reports/get-batch-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code,
                is_search: is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            //this.setState({storeID:''});
            response.data.map((store,index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            let res = []
            if (Array.isArray(this.state.storeID) && this.state.storeID) {
                const uniq = new Set(storeList.map(e => JSON.stringify(e)));

                storeList = Array.from(uniq).map(e => JSON.parse(e));

            }
            this.setState({
                storeList:storeList,
                is_store_loading: false
            })
        });
    }
    changeStore(login_type, store_object, checked_item, e) {
        if (login_type === 'store') {
            let value='';
            let sidArray = [];
            if(store_object.length<1){
                value = null;
                sidArray = '';
            }
            else{
                store_object.map((sids, i) => {
                    sidArray.push(sids.value)
                });
            }
            var is_enable = compareValues(sidArray, this.state.active_sids);
            this.setState({
                storeID: sidArray,
                storeValue:store_object,
                ciutidIds: '',
                ciutidValue: [],
                isChange: is_enable
            });
        } else {
            let item_list = this.state.storeID;
            let item_list_object = this.state.storeObject;
            let checked_list = store_object.value;
            let checked_list_object = store_object;
            //console.log(checked_list);
            if(checked_item===false) {
                const newData = [store_object, ...this.state.storeList.filter(item => item !== store_object)];
                this.setState({
                    storeID: [...this.state.storeID,  store_object.value],
                    storeObject: [...this.state.storeObject, store_object],
                    isChange: true,
                    storeList: newData,
                    ciutidIds: '',
                    ciutidValue: [],
                });

            } else{
                let index = item_list.indexOf(checked_list);
                if (index > -1) {
                    item_list.splice(index, 1);
                    if(item_list.length<1) {
                        item_list='';
                    }
                    this.setState({
                        storeID: item_list,
                        isChange: true,
                        ciutidIds: '',
                        ciutidValue: [],
                    })
                }
                let index_object = item_list_object.indexOf(checked_list_object);
                if (index_object > -1) {
                    item_list_object.splice(index_object, 1);
                    if(item_list_object.length<1) {
                        item_list_object=[];
                    }
                    this.setState({
                        storeObject: item_list_object,
                        isChange: true
                    })
                }
            }
            if (e.target.type === 'checkbox') {
                e.stopPropagation();
            }
        }


    }
    storeToggleList() {
        this.setState({
            storeListOpen: !this.state.storeListOpen,
        });
    }
    storeFilterList(e){
        var value = e.target.value

        setTimeout(function() {
            this.getStore(this.state.search_code, this.state.search_type, this.state.object_type, this.state.search_object_code,true, value);
        }.bind(this), 200);
    }
    closeStoreList() {
        this.setState({
            storeListOpen: false,
        });
    }
    _get_acq_banks(){
        axios.get(config.get('API_URL')+'/reports/acq-banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if(Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    change_acq_banks(optionSelected){ //console.log(optionSelected);
        let value='';
        let acqBankArray = [];
        if(optionSelected.length<1){
            value = null;
            acqBankArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                var index = this.state.acqBankList.findIndex(obj => obj.value==mids.value);
                this.state.acqBankList.move(index,0).join(',');
                mids.value.map((mids1, i) => {
                    acqBankArray.push(mids1)
                });
            });
        }
        var is_enable = compareValues(acqBankArray, this.state.active_bids);
        this.setState({
            acqBankIds:acqBankArray,
            acqBankValue:optionSelected,
            isChange: is_enable
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, acqBankArray, this.state.cityIds,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs);
    }
    _get_city(){
        axios.get(config.get('API_URL')+'/reports/get-city/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((city, index) => {
                    this.state.cityLists.push({value: city.city_name, label: city.city_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }
    changeCity(optionSelected){ //console.log(optionSelected);
        let value='';
        let cityArray = [];
        if(optionSelected===null){
            value = null;
        }
        else{
            optionSelected.map((mids, i) => {
                cityArray.push(mids.value)
                var index = this.state.cityLists.findIndex(obj => obj.value==mids.value);
                this.state.cityLists.move(index,0).join(',');
            });
        }
        var is_enable = compareValues(cityArray, this.state.active_cityids);
        this.setState({
            cityIds:cityArray,
            cityValue:optionSelected,
            isChange: is_enable,
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, cityArray,
            this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs,  this.state.emiIssuerIDs, this.state.emiSchemeIDs)
    }
    _get_issuing_banks(){
        axios.get(config.get('API_URL')+'/invoice/all_issuing_banks/',{
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((issuBank, index) => {
                    this.state.issuerBankList.push({value: issuBank.issuing_bank_id, label: issuBank.issuing_bank_name})
                });
            }
        });
        this.setState({
            loading:false
        })
    }

    handleEvent(event, picker, e) {
        this.setState({
            todSend: moment(picker.endDate).format('YYYY-MM-DD'),
            yestSend: moment(picker.startDate).format('YYYY-MM-DD'),
            datefromShow: moment(picker.startDate).format('D MMM YYYY'),
            dateToShow: moment(picker.endDate).format('D MMM YYYY')
        });
        if(event.type=='apply'){
            this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
                this.state.yestSend, this.state.todSend, this.state.metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs)
        }
    }
    changeMetric(metric, e) {
        var is_enable = compareValues(metric, this.state.active_metric);
        this.setState({
            metric:metric,
            isChange: is_enable
        });
        this.get_filtered_emi_sales_report(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.acqBankIds, this.state.cityIds,
            this.state.yestSend, this.state.todSend, metric, this.state.categoryIDs, this.state.brandIDs, this.state.modelIDs, this.state.tenureIDs, this.state.subventionIDs, this.state.emiIssuerIDs, this.state.emiSchemeIDs)
    }
    downloadEmiSales(type, dw_chain_code, e){

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: ''
        });
        var postData = {
            mids: this.state.merchantID,
            cids: this.state.chainID,
            sids: this.state.storeID,
            bids: this.state.acqBankIds,
            cityids: this.state.cityIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            metric: this.state.metric,
            download: true,
            type: type,
            sale_type: 'EMI',
            categoryIDs: this.state.categoryIDs,
            brand: this.state.brandIDs,
            model: this.state.modelIDs,
            tenure: this.state.tenureIDs,
            subvention: this.state.subventionIDs,
            emiIssuer:  this.state.emiIssuerIDs,
            emiScheme: this.state.emiSchemeIDs,
            dw_chain_code: dw_chain_code
        };

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/sales-reports-merchant-download",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = timestamp+'emi_sales_report.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){ //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.file_url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    changeAmtType(amt, e) {
        this.setState({
            amount_type:amt,
            isChange: true
        });

    }
    render() {
        const store_lists = this.state.storeList.map((store_object, index) => {
            // console.log("store_object");
            // console.log(store_object);
            var chks_input = <input type='checkbox' checked={false}/>
            var activeCls_s = 'dd-list-item';
            var checked_items = false;
            if(this.state.storeID.includes(store_object.value) === true){
                chks_input = <input type='checkbox' checked={true}/>
                activeCls_s = "dd-list-item dd-list-active";
                checked_items = true;
            }
            return (
                <li key={index} className={activeCls_s} onClick={this.changeStore.bind(this, '', store_object,checked_items)}>
                    {chks_input}
                    &nbsp;&nbsp;{store_object.label}
                </li>
            )
        })
        const MenuList = props => {
            const rows = props.children;
            let no_of_rows = 0;
            let drop_down_heigth = 0
            if(rows.length!== undefined){
                no_of_rows = rows.length;
                if(no_of_rows<9) {drop_down_heigth = 40*no_of_rows;}
                else{
                    drop_down_heigth = 300;
                }

            }
            const rowRenderer = ({ key, index, isScrolling, isVisible, style }) => (
                <div key={key} style={style}>{rows[index]}</div>
            );

            return (
                <List
                    style={{ width: '100%' }}
                    width={300}
                    height={drop_down_heigth}
                    rowHeight={30}
                    rowCount={no_of_rows}
                    rowRenderer={rowRenderer}
                />
            )
        }

        var vcls = "btn btn-sm btn-default switchMetric";
        var ccls = "btn btn-sm btn-default switchMetric";
        if(this.state.metric=='volume' ) {
            vcls = "btn btn-sm btn-primary switchMetric";
            ccls = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.metric=='count' ) {
            vcls = "btn btn-sm btn-default switchMetric";
            ccls = "btn btn-sm btn-primary switchMetric";
        }
        var vcls1 = "btn btn-sm btn-default switchMetric";
        var ccls1 = "btn btn-sm btn-default switchMetric";
        if(this.state.amount_type=='Thousand' ) {
            vcls1 = "btn btn-sm btn-primary switchMetric";
            ccls1 = "btn btn-sm btn-default switchMetric";
        }
        if(this.state.amount_type=='Lakhs' ) {
            vcls1 = "btn btn-sm btn-default switchMetric";
            ccls1 = "btn btn-sm btn-primary switchMetric";
        }
        const customStyles = {
            control: provided => ({
                ...provided,
                padding:"0px",
                minHeight: "15px",
            }),
            indicatorsContainer: provided => ({
                ...provided,
                height: "23px"
            }),
            clearIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            dropdownIndicator: provided => ({
                ...provided,
                padding: "5px"
            }),
            valueContainer: base => ({
                ...base,
                padding: '0px 6px'
            }),
            menu: styles => ({ ...styles, zIndex: 999 })
        };
        return(
         
            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">EMI Sales Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-10 filter-border-right">
                                    {this.state.merchant_list_box ===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label>Merchants</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                                        isLoading={this.state.is_merchant_loading}
                                                components={{ MenuList }}
                                                value={this.state.merchantValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeMerchant.bind(this,'')}
                                                options={this.state.merchantList}
                                                placeholderButtonLabel="Select [Merchant]"
                                            />

                                            <div className="clearfix"></div>
                                        </div> : null}
                                    {this.state.chain_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5">
                                            <label> Chain </label>
                                            <ReactMultiSelectCheckboxes name="chain"
                                                isMulti
                                                                        isLoading={this.state.is_chain_loading}
                                                components={{ MenuList }}
                                                value={this.state.chainValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeChain.bind(this,'')}
                                                options={this.state.chainList}
                                                placeholderButtonLabel="Select [Chain]"
                                            />
                                            <div className="clearfix"></div>
                                        </div>: null }
                                    {this.state.store_list_box===true?
                                        <div className="col-md-2 filter-bottom5 padd-5" >
                                            <label> Store: </label>
                                            <div className="dd-wrapper">
                                                <div className="dd-header" onClick={() => this.storeToggleList()}>
                                                    {this.state.storeID==''?
                                                        <div className="dd-header-title">{this.state.storeHeaderTitle}</div>:
                                                        <div className="dd-header-title">{this.state.storeID.length} Selected</div>
                                                    }

                                                    <i className="fa fa-angle-down"></i>
                                                </div>
                                                {this.state.storeListOpen ===true?
                                                    <div
                                                        role="list"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <input
                                                            className="dd-list-search-bar"
                                                            placeholder="Search"
                                                            onChange={(e) => this.storeFilterList(e)}
                                                        />
                                                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                                                        {/*<div className="dd-scroll-list">*/}
                                                        <ul className="dd-list">
                                                            {this.state.is_store_loading===true?
                                                                <li>
                                                                    <BeatLoader
                                                                        css={override}
                                                                        sizeUnit={"px"}
                                                                        size={5}
                                                                        color={'#666666'}
                                                                        loading={this.state.is_store_loading}
                                                                    />
                                                                </li>: null}
                                                            {store_lists}

                                                        </ul> </div>: null }
                                                {/*</div>*/}
                                            </div>
                                            <div className="clearfix"></div>
                                        </div>: null }

                                    {/*    <div className="clearfix"></div>*/}
                                    {/*</div>*/}
                                    {/*<div className="gap_ver"></div>*/}
                                    {/*<div className="row">*/}
                                    {/*{this.state.acq_bank_list_box===true?*/}
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Acquirer:</label>
                                        <ReactMultiSelectCheckboxes name="acqurier"
                                                isMulti
                                                value={this.state.acqBankValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.change_acq_banks.bind(this)}
                                                options={this.state.acqBankList}
                                                placeholderButtonLabel="Select [Acquirer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    {/*: null }*/}
                                    {/*<div className="col-md-3">*/}
                                    {/*    <label> Issuer: </label>*/}
                                    {/*    <ReactMultiSelectCheckboxes name="issuer"*/}
                                    {/*            isMulti*/}
                                    {/*            value={this.state.issuerBankValue}*/}
                                    {/*            styles={customStyles} className="report-listbox"*/}
                                    {/*            isClearable={false}*/}
                                    {/*            onChange={this.changeChain.bind(this,'')}*/}
                                    {/*            options={this.state.issuerBankList}*/}
                                    {/*            placeholderButtonLabel="Select[Issuer]"*/}
                                    {/*    />*/}
                                    {/*    <div className="clearfix"></div>*/}
                                    {/*</div>*/}
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> City: </label>
                                        <ReactMultiSelectCheckboxes name="city"
                                                isMulti
                                                components={{ MenuList }}
                                                value={this.state.cityValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeCity.bind(this)}
                                                options={this.state.cityLists}
                                                placeholderButtonLabel="Select [City]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Category </label>
                                        <ReactMultiSelectCheckboxes name="category"
                                                isMulti
                                                value={this.state.categoryValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeCategory.bind(this)}
                                                options={this.state.categoryLists}
                                                placeholderButtonLabel="Select [Category]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>

                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label>Brand:</label>
                                        <ReactMultiSelectCheckboxes name="brand"
                                                isMulti
                                                value={this.state.brandValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeBrand.bind(this)}
                                                options={this.state.brandLists}
                                                placeholderButtonLabel="Select [Brand]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Model: </label>
                                        <ReactMultiSelectCheckboxes name="model"
                                                isMulti
                                                value={this.state.modelValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeModel.bind(this)}
                                                options={this.state.modelLists}
                                                placeholderButtonLabel="Select[Model]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Tenure: </label>
                                        <ReactMultiSelectCheckboxes name="tenure"
                                                isMulti
                                                value={this.state.tenureValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeTenure.bind(this)}
                                                options={this.state.tenureLists}
                                                placeholderButtonLabel="Select [Tenure]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> Subvention </label>
                                        <ReactMultiSelectCheckboxes name="subvention"
                                                isMulti
                                                value={this.state.subventionValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeSubvention.bind(this)}
                                                options={this.state.subventionLists}
                                                placeholderButtonLabel="Select [Subvention]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Issuer: </label>
                                        <ReactMultiSelectCheckboxes name="emi_issure"
                                                isMulti
                                                value={this.state.emiIssuerValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiIssuer.bind(this)}
                                                options={this.state.emiIssuerLists}
                                                placeholderButtonLabel="Select [EMI Issuer]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="col-md-2 filter-bottom5 padd-5">
                                        <label> EMI Scheme: </label>
                                        <ReactMultiSelectCheckboxes name="emi_scheme"
                                                isMulti
                                                value={this.state.emiSchemeValue}
                                                styles={customStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeEmiScheme.bind(this)}
                                                options={this.state.emiSchemeLists}
                                                placeholderButtonLabel="Select [ EMI Scheme]"
                                        />
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="clearfix"></div>
                                        </div>
                                        <div className="col-md-2 filter-bottom5 ">
                                            <div>
                                                <label>Metric</label>
                                                <div className="alignedCenter">
                                                    <div className="btn-group">
                                                        <button className={vcls} type="button" value="volume" onClick={this.changeMetric.bind(this,'volume')}>volume </button>
                                                        <button className={ccls} type="button" value="count" onClick={this.changeMetric.bind(this,'count')}>count </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{marginTop:'10px'}}>
                                                <label>Amount Notation</label>
                                                <div className="alignedCenter">
                                                    <div className="btn-group">
                                                        <button className={vcls1} type="button" value="Thousand" onClick={this.changeAmtType.bind(this,'Thousand')}>Thousand </button>
                                                        <button className={ccls1} type="button" value="Lakhs" onClick={this.changeAmtType.bind(this,'Lakhs')}>Lakhs </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_export ?
                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.downloadEmiSales.bind(this, 'merchant', '')}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>: null }

                                    <div className="clearfix"></div>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loadingtable}
                                    />
                                    {this.state.is_record ?
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                            <table id="EmiSalesReports" className="table table-striped table-hover">

                                            </table>
                                        </div>:
                                        <div className="empty_data"> No record Found</div>
                                    }

                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    {this.state.is_export2 ?
                                        <div className="">
                                            <a href="#" className="exportButton" role="button" onClick={this.downloadEmiSales.bind(this, 'store', this.state.store_level_chain_code)}>
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                                Export to CSV
                                            </a>
                                        </div>: null }
                                    <div id="StoreLabel" className="content-tdetails-table table-full-width table-responsive marginTop0">
                                        <table id="EmiSalesReportsStore" className="table table-striped table-hover">

                                        </table>
                                    </div>
                                    <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                        <div className="download-popup-model">
                                            <div className="message-content">
                                                {this.state.file_url==''?
                                                    <div>
                                                        <p>Generating CSV...</p>
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                                                        </a>
                                                    </div>
                                                    :
                                                    <div className="dwnloadLink">
                                                        <a href="#" onClick={this.downloadFile.bind(this)}>
                                                            <i className="fa fa-download" aria-hidden="true"></i>Download
                                                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                            <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                        </a>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </ModalD>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           );
            
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
    currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
  }
  export default connect(null,mapDispatchToProps)(EmiSalesReport);